export default __webpack_public_path__ + "images/logoElle.33ac3d3b701464642616b410967a6015.svg"